import React from 'react'
import SicorLogoColor from '../../img/logos/color_logo.png'
import DefaultPicture from '../../img/commons/default_picture.png'
import moment from 'moment'

export default class NavigationBar extends React.Component {
  render () {
    var profilePicture = this.props.data.patientImage ? this.props.data.patientImage : DefaultPicture
    var dateExamn  =  moment(this.props.data.medicalData.timestamp,'x').format("DD/MM/YYYY")

    return (
      <div className='navigation-bar-printable'>
        <div className='navigation-conatiner'>
          <div className="head-left">
            <img className='' src={SicorLogoColor} />
            <div className="title-">Evaluación de Salud Cardiovascular y Reserva Funcional ({dateExamn})</div>
          </div>
          <div className="head-right">
            <div className='patient-personal-information-printable'>
              <div className='image-container'>
                <img id='photo' className='patient-photo-printable' src={profilePicture}/>
              </div>
              <div className='data-container-printable'>
                <label className='data' id='patientFullName'>{this.props.data.patientFullName}</label>
                <label className='data' id='patientDocument'>{this.props.data.patientIdentification}</label>
                <label className='data' id='patientAge'>Edad: {this.props.data.patientAge} años</label>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
}

NavigationBar.propTypes = {
  data: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDashboard/Header.js